<template>
  <div class="head clear">
    <div class="left" style="display: table-cell;vertical-align: middle">
      <div class="banner-img" style="margin-top: 20px;vertical-align: middle;" :style="{'background-image':`url(${cIcon})`}"></div>
      <div class="" style="display: inline-block;vertical-align: middle;">
        <p style="font-size: 20px;">{{cTitle}}</p>
        <p style="font-size: 16px;">{{cStart|formateTime}}-{{cEnd|formateTime2}}</p>
      </div>
    </div>
    <div class="right" style="margin-top: 33px;">
      <img style="margin-top: 10px;" src="http://medcircle.cn/lib/ydt/logo.png" alt="">
    </div>
  </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props: ['cTitle','cStart','cEnd','cIcon'],
        filters:{
          formateTime(time){
              let str = new Date(time).Format('yyyy.MM.dd');
              return str;
          },
          formateTime2(time){
            let str = new Date(time).Format('MM.dd');
            return str;
          }
        },
        methods: {},
        computed: {},
        mounted(){

        }
    }
</script>
<style scoped>
  .clear:after {
    content: '';
    display: block;
    clear: both;
  }
  .banner-img {
    width: 300px;
    height: 177px;
    margin-right: 20px;
    display: inline-block;
    background: url(./logo.png) no-repeat center top/cover;
    /*vertical-align: middle;*/
  }
  .left {
    float: left;
  }

  .right {
    float: right;
  }
  .head {
    font-size: 16px;
    color: #000000;
  }

</style>



// WEBPACK FOOTER //
// hdHead.vue?546521fd